import type { Character, LobbyState } from './lobbyStore.types';

export const charactersSlice: Pick<
  LobbyState,
  | 'characters'
  | 'selectedCharacterId'
  | 'charCreationCharId'
  | 'setCharacters'
  | 'addCharacter'
  | 'updateCharacter'
  | 'selectCharacter'
  | 'setCharCreationCharId'
  | 'setCharacterReady'
> = {
  characters: [],
  selectedCharacterId: null,
  charCreationCharId: null,

  setCharacters: (characters: Character[]) => ({ characters }),

  addCharacter: (character: Character) => (state: LobbyState) => ({
    characters: [...state.characters, character],
  }),

  updateCharacter: (id: string, updates: Partial<Character>) => (state: LobbyState) => ({
    characters: state.characters.map((c: Character) => (c.id === id ? { ...c, ...updates } : c)),
  }),

  selectCharacter: (id: string | null) => ({
    selectedCharacterId: id,
  }),

  setCharCreationCharId: (charId: string | null) => ({
    charCreationCharId: charId,
  }),

  setCharacterReady: (id: string, isReady: boolean) => (state: LobbyState) => ({
    characters: state.characters.map((c: Character) => (c.id === id ? { ...c, isReady } : c)),
  }),
};
